import watzoujijdoenSoundOld from '../../assets/sounds/watzoujijdoenOld.wav';
import watzoujijdoenSoundNew from '../../assets/sounds/watzoujijdoenNew.wav';
import introSound from '../../assets/sounds/intro.wav';
import outroSound from '../../assets/sounds/outro.wav';

export const Audio = () => {
	return (
		<>
			<audio id="decisions-sound-old">
				<source src={watzoujijdoenSoundOld} type="audio/wav"/>
			</audio>

			<audio id="decisions-sound-new">
				<source src={watzoujijdoenSoundNew} type="audio/wav"/>
			</audio>

			<audio id="intro-sound">
				<source src={introSound} type="audio/wav"/>
			</audio>

			<audio id="outro-sound">
				<source src={outroSound} type="audio/wav"/>
			</audio>
		</>
	);
};